<template>
  <div class=" pb-16">
    <app-bar :showtab="false">
      <template v-slot:title>云黑库列表</template>
      <template v-slot:fun-icons>
        <v-btn icon to="/user/cloud/create">
          <v-icon>mdi-archive-plus</v-icon>
        </v-btn>
      </template>
    </app-bar>

    <v-row dense>
      <v-col
        v-for="(item, index) in list"
        :key="item.uuid"
        col="12"
        sm="6"
        lg="4"
      >
        <v-card>
          <v-card-title>
            {{ item.name }}
          </v-card-title>
          <v-card-subtitle>
            {{ item.server_type }}
          </v-card-subtitle>
          <v-card-text>
            云黑库UUID：{{ item.uuid }}<br />
            服务器地址：{{ item.server }}<br />

            记录数量：{{ item.list_num }} 条
          </v-card-text>
          <v-card-actions>
            <v-btn text color="error" @click="deleteDialogShow(index)"
              >删除</v-btn
            >
            <v-spacer />
            <v-btn
              text
              color="info"
              target="_blank"
              :href="
                'https://motdbe.blackbe.work/?ip=' +
                item.server.split(':')[0] +
                '&port=' +
                item.server.split(':')[1]
              "
            >
              MOTDBE
            </v-btn>
            <v-btn
              text
              color="info"
              :to="'/user/cloud/create?edit=' + item.uuid"
              >修改信息</v-btn
            >
            <v-btn text color="info" :to="'/cloud/' + item.uuid">查看</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-btn fab dark color="pink" @click="refresh" bottom right fixed>
      <v-icon>mdi-refresh</v-icon>
    </v-btn>
    <v-dialog v-model="deleteDialog">
      <v-card>
        <v-card-title>删除云黑库</v-card-title>
        <v-card-text>
          删除云黑库后，其下的所有条目将全部删除！
          <br />
          <b>不 可 恢 复 ！</b>
          <b>不 可 恢 复 ！</b>
          <b>不 可 恢 复 ！</b>
          <br />
          <span class="red--text"
            >如果你确定要删除，请输入 "删除{{
              list[deleteIndex] ? list[deleteIndex].name : "null"
            }}" 删除</span
          >
          <v-text-field
            v-model="delete_code"
            label="请输入"
            required
            hide-details
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="deleteDialog = false">
            取消
          </v-btn>
          <v-btn color="error" text @click="deleteCloud">删除 </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import AppBar from "@/components/common/AppBar/AppBar";
import list from "../../networker/list";
import EventBus from "@/tools/event-bus";
export default {
  name: "cloud",
  components: {
    AppBar,
  },
  data() {
    return {
      list: [],

      deleteDialog: false,
      deleteIndex: 0,
      delete_code: "",
    };
  },
  async mounted() {
    this.refresh();
  },
  methods: {
    //list刷新
    async refresh() {
      let res = await list.getRepList();
      if (res.data.success) {
        this.list = res.data.data.list;
      } else {
        this.list = [];
        EventBus.$emit("snackbar", {
          text: res.data.message,
          color: "error",
        });
      }
    },
    deleteDialogShow(index) {
      this.deleteDialog = true;
      this.deleteIndex = index;
    },
    async deleteCloud() {
      if (this.delete_code == "删除" + this.list[this.deleteIndex].name) {
        let res = await list.delRep(this.list[this.deleteIndex].uuid);
        if (res.data.success) {
          this.refresh();
          this.deleteDialog = false;
          this.delete_code = "";
          EventBus.$emit("snackbar", {
            text: res.data.message,
          });
        }
      } else {
        EventBus.$emit("snackbar", {
          text: "删除失败，请输入正确的删除码",
          color: "error",
        });
      }
    },
  },
};
</script>